<h3 style="margin-bottom: 20px">{{ "NAV_DASHBOARD" | translate }}</h3>

<div class="row">
  <div class="col-md-5 dashboard-left-col">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header-white header-underline">
            <h6 class="white-header-text">
              {{ "CUSTOMER_INFO" | translate }}
            </h6>
            @if (customerInformation && !customerEdit && user.roleLevel >= 150) {
              <span
                class="fa-light fa-lg fa-pen-to-square float-right customerEdit"
                (click)="startCustomerEdit()">
              </span>
            }
          </div>
          <div class="card-body-white">
            <div class="customerPanel">
              <!--Customer information display page-->
              @if (!customerEdit && customerInformation) {
                <div>
                  <div>
                    {{ customerInformation?.name }} ({{ customerInformation?.customerId }})<br />
                    {{ customerInformation?.address }}<br />
                    {{ customerInformation?.postCode }}
                    {{ customerInformation?.postOffice }}<br />
                  </div>
                  <div class="float-right">
                    <small>
                      {{ "CUST_ADDED_TO_SYSTEM" | translate }}
                      {{ $safeNavigationMigration(customerInformation?.addedToSystem) | moment : "l" }}
                    </small>
                  </div>
                  @if (enabledFeatures) {
                    <div class="pt-2">
                      <hr />
                      <strong>{{ "ENABLED_FEATURES" | translate }}</strong>
                      <ul class="companyFeatures">
                        @for (feature of enabledFeatures; track feature) {
                          <li>
                            <span class="fa-light fa-fw" [ngClass]="getFeatureClass(feature)"></span>
                            {{ feature | translate }}
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </div>
              }
              <!--Customer information editing form-->
              @if (customerEdit) {
                <div>
                  <form (ngSubmit)="formSubmitSubject.next()" #customerEditForm="ngForm">
                    <div class="form-group">
                      <label>{{ "NAME" | translate }}</label>
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="customerInformation.name"
                        name="customerName"
                        #customerName="ngModel"
                        required
                        />
                      </div>
                      <div class="form-group">
                        <label>{{ "ADDRESS" | translate }}</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="customerInformation.address"
                          name="customerAddress"
                          #customerAddress="ngModel"
                          required
                          />
                        </div>
                        <div class="form-group">
                          <label>{{ "POSTCODE" | translate }}</label>
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="customerInformation.postCode"
                            name="customerPostCode"
                            #customerPostCode="ngModel"
                            required
                            />
                          </div>
                          <div class="form-group">
                            <label>{{ "POSTOFFICE" | translate }}</label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="customerInformation.postOffice"
                              name="customerPostOffice"
                              #customerPostOffice="ngModel"
                              required
                              />
                            </div>
                            <div class="form-group">
                              <hr />
                              <strong>{{ "ENABLED_FEATURES" | translate }}</strong>
                              @if (user.roleLevel > 100) {
                                <ul class="companyFeatures allFeatures">
                                  @for (feature of allFeatures; track feature) {
                                    <li
                                      [ngClass]="{ enabledFeature: isFeatureEnabled(feature), disabledFeature: !canEnableFeature(feature) }"
                                      (click)="enableFeature(feature)"
                                      >
                                      <span  class="fa-light fa-fw" [ngClass]="getFeatureClass(feature)"></span>
                                      {{ feature | translate }}
                                      @if (feature === 'EnrichedAlerts') {
                                        <span
                                          class="fa-light fa-circle-info ml-1"
                                          [matTooltip]="'ENRICHED_ALERTS_GDPR_WARNING' | translate"
                                          (click)="$event.stopPropagation()">
                                        </span>
                                      }
                                    </li>
                                  }
                                </ul>
                              } @else {
                                <ul class="companyFeatures">
                                  @for (feature of enabledFeatures; track feature) {
                                    <li>
                                      <span class="fa-light fa-fw" [ngClass]="getFeatureClass(feature)"></span>
                                      {{ feature | translate }}
                                    </li>
                                  }
                                </ul>
                                @if (!enabledFeatures) {
                                  <span>{{ "NO_FEATURES_ENABLED" | translate }}</span>
                                }
                              }
                              <!--Show only enabled features if user role is not high enough for feature modification-->
                            </div>
                            <!--Components for main users and admins-->
                            @if (user.roleLevel >= 100) {
                              <div>
                                <div class="form-group">
                                  <label>{{ "PASSWORD_EXPIRATION" | translate }}</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="customerInformation.passwordExpirationDays"
                                    name="passwordExpirationDays"
                                    #passwordExpirationDays="ngModel"
                                    />
                                  </div>
                                </div>
                              }
                              <!-- Components for only admins -->
                              @if (user.roleLevel === 200) {
                                <div>
                                  <div class="form-group">
                                    <label>{{"AUTOMATIC_LOGOUT_TIME" |translate}}</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      [(ngModel)]="customerInformation.portalAutomaticLogoutMinutes"
                                      name="portalAutomaticLogoutMinutes"
                                      #portalAutomaticLogoutMinutes="ngModel"
                                      />
                                    </div>
                                    <div class="form-group">
                                      <label>DefContLim (e.g M5 = 5 minutes)</label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        [(ngModel)]="customerInformation.defContLim"
                                        name="customerDefContLim"
                                        #customerDefContLim="ngModel"
                                        />
                                      </div>
                                      <div class="form-group">
                                        <label>{{ "EMA_TAG_ONLY" | translate }}</label>
                                        <section>
                                          <mat-slide-toggle [(ngModel)]="customerInformation.emaTagOnly" name="customerEmaTagOnly"></mat-slide-toggle>
                                        </section>
                                      </div>
                                      <div class="form-group">
                                        <div class="form-group">
                                          <label>RoamingDelay (seconds)</label>
                                          <input
                                            type="text"
                                            class="form-control"
                                            [(ngModel)]="customerInformation.roamingDelay"
                                            name="customerRoamingDelay"
                                            #customerRoamingDelay="ngModel"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    <div class="form-group">
                                      <button
                                        [disabled]="!featuresChanged && (customerEditForm.invalid || customerEditForm.pristine)"
                                        type="submit"
                                        class="btn btn-outline-primary mr-2"
                                        >
                                        <span class="fa-light fa-floppy-disk"></span>
                                        {{ "SAVE" | translate }}
                                      </button>
                                      <button class="btn btn-outline-danger" (click)="cancelCustomerEdit()">
                                        <span class="fa-light fa-xmark"></span>
                                        {{ "CANCEL" | translate }}
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              }
                              <!--Two factor authentication configuration: part of the Main user and Customer admin built-in roles-->
                              @if (canConfigureTwoFactor && isFeatureEnabled('EnhancedSecurity', false)) {
                                <div
                                  >
                                  <hr />
                                  @if (customerInformation) {
                                    <two-factor-authentication></two-factor-authentication>
                                  }
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    @if (notifications) {
                      <div class="row" style="margin-top: 20px">
                        <div class="col-md-12">
                          <div class="card">
                            <div class="card-header-white header-underline">
                              <h6 class="white-header-text">
                                {{ "NEWS" | translate }}
                              </h6>
                            </div>
                            <div class="card-body-white" style="padding-top: 15px">
                              @for (notification of notifications; track notification) {
                                <div>
                                  <div [ngClass]="notification.highlight ? 'notificationHighlight' : ''">
                                    <strong>{{ notification.subject }}</strong><br />
                                    <small>{{ notification.timestamp | moment : "l LTS" }}</small>
                                    <p [innerHTML]="notification.message"></p>
                                  </div>
                                  <hr />
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                  <div class="col-md-7 dashboard-right-col">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="deviceOnlineStatus">
                          <div class="card">
                            <div class="card-header-white header-underline">
                              <h6 class="white-header-text">
                                {{ "DEVICES_STATUS" | translate }}
                              </h6>
                              <div class="device-status">
                                <div class="float-right">
                                  <mat-slide-toggle (change)="showBaseDevicesOnly = !showBaseDevicesOnly; getOnlineStatus(showBaseDevicesOnly)"></mat-slide-toggle>
                                </div>

                                <label class="float-right mr-2">{{ "SHOW_BASE_STATIONS_ONLY" | translate }}</label>
                              </div>
                            </div>
                            <div class="card-body-white">
                              <devicestatus
                                [showBaseDevicesOnly]="showBaseDevicesOnly"
                                [type]="'Online'"
                                [class]="'statusOnline'"
                                [data]="$safeNavigationMigration(onlineStatus?.online)"
                                [title]="'Online' | translate"
                                [description]="'DEVICE_STATUS_ONLINE_DESCRIPTION' | translate"
                                (onDeviceExcluded)="getOnlineStatus(showBaseDevicesOnly)"
                              ></devicestatus>

                              <devicestatus
                                [showBaseDevicesOnly]="showBaseDevicesOnly"
                                [type]="'OfflineUnder24h'"
                                [class]="'statusOfflineUnder'"
                                [data]="$safeNavigationMigration(onlineStatus?.offlineUnder24h)"
                                [title]="'OfflineUnder24h' | translate"
                                [description]="'DEVICE_STATUS_OFFLINE_UNDER_24H_DESCRIPTION' | translate"
                                (onDeviceExcluded)="getOnlineStatus(showBaseDevicesOnly)"
                              ></devicestatus>

                              <devicestatus
                                [showBaseDevicesOnly]="showBaseDevicesOnly"
                                [type]="'OfflineOver24h'"
                                [class]="'statusOfflineOver'"
                                [data]="$safeNavigationMigration(onlineStatus?.offlineOver24h)"
                                [title]="'OfflineOver24h' | translate"
                                [description]="'DEVICE_STATUS_OFFLINE_OVER_24H_DESCRIPTION' | translate"
                                (onDeviceExcluded)="getOnlineStatus(showBaseDevicesOnly)">
                              </devicestatus>

                              <devicestatus
                                [showBaseDevicesOnly]="showBaseDevicesOnly"
                                [type]="'LowBattery'"
                                [class]="'statusLowBattery'"
                                [data]="$safeNavigationMigration(onlineStatus?.lowBattery)"
                                [title]="'BATTERY_STATUS_WARNING' | translate"
                                [description]="'DEVICE_STATUS_LOW_BATTERY_DESCRIPTION' | translate"
                                (onDeviceExcluded)="getOnlineStatus(showBaseDevicesOnly)"
                              ></devicestatus>

                              <devicestatus
                                [showBaseDevicesOnly]="showBaseDevicesOnly"
                                [type]="'Excluded'"
                                [class]="'statusExcluded'"
                                [data]="$safeNavigationMigration(onlineStatus?.excluded)"
                                [title]="'EXCLUDED_DEVICES' | translate"
                                [description]="'DEVICE_STATUS_EXCLUDED_DESCRIPTION' | translate"
                                (onDeviceRemoved)="getOnlineStatus(showBaseDevicesOnly)"
                              ></devicestatus>
                              <!--<devicestatus [showBaseDevicesOnly]="showBaseDevicesOnly" [type]="'productStatus'" [class]="'statusDeviceRegistry'" [data]="onlineStatus?.productStatus" [title]="'PRODUCT_STATUS' |translate"></devicestatus>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Active alerts-->
                    <div class="row" style="margin-top: 10px">
                      <div class="col-md-12">
                        <app-active-alerts></app-active-alerts>
                      </div>
                    </div>
                    <!--Training videos-->
                    @if (lang === 'fi') {
                      <div class="row" style="margin-top: 10px">
                        <training-videos></training-videos>
                      </div>
                    }
                  </div>
                </div>
